import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import type { PropsWithChildren } from 'react';
import { useId, useEffect, memo } from 'react';
import { pageTitleIdAtom, pageTitleTextAtom } from '../layout/gnb/MobileNav';
import { breakpointMedium } from '@/constants/breakpoints';

type PageTitleProps = {
  title?: string,
};

const Container = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 60px 0;

@media (max-width: ${breakpointMedium}) {
  padding: 32px 0;
}
`;

const TitleText = styled.h1`
font-size: 30px;
font-weight: 700;
line-height: 43px;

@media (max-width: ${breakpointMedium}) {
  font-size: 22px;
  line-height: 32px;
}
`;

const PageTitle = ({ children, title }: PropsWithChildren<PageTitleProps>) => {
  const setPageTitleId = useSetAtom(pageTitleIdAtom);
  const setPageTitleText = useSetAtom(pageTitleTextAtom);
  const pageTitleId = useId();

  useEffect(() => {
    setPageTitleId(pageTitleId);
    return () => setPageTitleId(null);
  }, [pageTitleId, setPageTitleId]);

  useEffect(() => {
    title && setPageTitleText(title);
    return () => setPageTitleText(null);
  }, [setPageTitleText, title]);

  return (
    <Container id={pageTitleId}>
      {title && <TitleText>{title}</TitleText>}
      {children}
    </Container>
  );
};

export default memo(PageTitle);
